import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

interface NavItem {
  name: string;
  isHover: boolean;
  url: string;
}

@Component({
  selector: 'app-navigation',
  imports: [RouterLink],
  templateUrl: './navigation.html',
  styleUrl: './navigation.css',
})
export class Navigation {
  private readonly router = inject(Router);

  navItems: NavItem[] = [
    { name: 'about', isHover: false, url: 'about' },
    { name: 'faq', isHover: false, url: 'faq' },
    { name: 'shop', isHover: false, url: 'shop' },
    { name: 'contact', isHover: false, url: 'contact' },
  ];

  // Each nav item has an -on and an -off image. Show -on while the route is
  // active or the pointer is over it, -off otherwise.
  getNavImage(navItem: NavItem): string {
    const active = this.router.url.indexOf(navItem.name) !== -1;
    const state = active || navItem.isHover ? 'on' : 'off';
    return `/assets/nav-${navItem.name}-${state}.png`;
  }
}
